import { motion } from "framer-motion";
import { CalendarCheck, ShieldCheck, Clock, Phone, Mail } from "lucide-react";
import SquareBookingWidget from "@/components/SquareBookingWidget";

const Book = () => (
  <main data-testid="book-view" className="pt-24 pb-16 sm:pb-20 min-h-screen">
    <div className="max-w-5xl mx-auto px-4 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="font-mono text-xs tracking-[0.25em] text-velocity uppercase font-bold mb-3">
          Live Availability
        </p>
        <h1 className="font-display font-black uppercase tracking-tight text-3xl sm:text-6xl leading-none">
          Book Your <span className="text-velocity">Install.</span>
        </h1>
        <p className="mt-4 max-w-xl text-slate-400 leading-relaxed text-sm sm:text-base">
          Pick a service and a time that works — you're booking straight into the studio's real calendar. A deposit is
          collected securely by Square at booking and applied to your total.
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.15 }}
        className="mt-8 sm:mt-10 rounded-2xl border border-edge bg-panel p-3 sm:p-6"
      >
        <SquareBookingWidget />
      </motion.div>

      <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
        {[
          { icon: CalendarCheck, text: "Real-time calendar — no phone tag" },
          { icon: ShieldCheck, text: "Deposit handled securely by Square" },
          { icon: Clock, text: "Confirmation and reminders by email & text" },
        ].map((f, i) => (
          <div
            key={i}
            className="flex items-center gap-3 rounded-xl border border-edge bg-panel px-4 py-3.5"
          >
            <f.icon className="h-5 w-5 text-velocity shrink-0" />
            <p className="text-xs sm:text-sm text-slate-300">{f.text}</p>
          </div>
        ))}
      </div>

      <div
        data-testid="booking-fallback-strip"
        className="mt-4 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 rounded-xl border border-edge bg-gunmetal px-4 py-4 text-sm text-slate-400"
      >
        <span>Calendar not loading or prefer to talk first?</span>
        <a href="tel:+14793100682" data-testid="booking-fallback-phone" className="inline-flex items-center gap-2 text-white hover:text-velocity transition-colors font-medium">
          <Phone className="h-4 w-4 text-velocity" /> (479) 310-0682
        </a>
        <a href="mailto:g5autorestyling@gmail.com" data-testid="booking-fallback-email" className="inline-flex items-center gap-2 text-white hover:text-velocity transition-colors font-medium">
          <Mail className="h-4 w-4 text-velocity" /> g5autorestyling@gmail.com
        </a>
      </div>
    </div>

    <section data-testid="booking-info" className="max-w-3xl mx-auto px-4 sm:px-8 mt-12 sm:mt-16 border-t border-edge pt-8 sm:pt-10">
      <h2 className="font-display font-bold text-xl sm:text-2xl tracking-tight mb-4">Book Your Wrap or Tint Appointment Online</h2>
      <div className="space-y-4 text-sm text-slate-400 leading-relaxed">
        <p>Skip the phone tag — our booking calendar shows the studio's real availability so you can lock in a time that fits your schedule. Choose a free wrap consultation to review film samples and pricing in person, or book an install slot directly if you already know what you want. Appointments are confirmed instantly with email and text reminders, and a small deposit secures your spot on the schedule. The deposit applies to your final total, so you're not paying anything extra — it just guarantees your bay time.</p>
        <p>Our Springdale studio on US-412 serves all of Northwest Arkansas, and most tint jobs finish same-day while full wraps typically take three to five working days. If you're planning around a car show, a sale, or a fleet launch, book early — install windows fill fast in spring and summer. Prefer to talk it through first? Call us at (479) 310-0682 during business hours or send a quote request and we'll help you pick the right service before you commit to a date.</p>
      </div>
    </section>
  </main>
);

export default Book;
